export default __webpack_public_path__ + "public/images/services/Document.png?c49c73f8";